module.exports = __webpack_public_path__ + "media/images/s01_06-b362e3fa6212257b421f3c09e5aed4c4.svg";